exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NbEZOQN3W2sVYdpSriBzT{display:block;white-space:nowrap;overflow:hidden;width:100%;position:relative}._3yEteU1OKx4wqhkHytwSeX{max-width:calc(100% - 140px);overflow:hidden;text-overflow:ellipsis;display:inline-block}html[dir=ltr] ._3yEteU1OKx4wqhkHytwSeX{text-align:right}html[dir=rtl] ._3yEteU1OKx4wqhkHytwSeX{text-align:left}._3yEteU1OKx4wqhkHytwSeX._1dvVYuHZz0-awwXYGgnDJD{max-width:calc(100% - 16px)}", ""]);

// exports
exports.locals = {
	"truncatedRecipientsContainer": "NbEZOQN3W2sVYdpSriBzT",
	"truncatedOnlyChildRecipient": "_3yEteU1OKx4wqhkHytwSeX",
	"noTruncatedRecipients": "_1dvVYuHZz0-awwXYGgnDJD"
};